export class FormErrorModel {

  constructor(
    public hasError: boolean,
    public error?: any
  ) {
  }

}
